import { shape, string } from 'prop-types';
import React from 'react';
import Image from 'components/Image';
import { FULL_VIEWPORT } from 'util/images/responsiveImages';
import styles from './styles';

function PageHeader(props) {
  const { color, image, title, description } = props;

  const hasImage = image && image.url;

  // keeping logic here to keep logic out of SprinkleBundle
  if (!hasImage && !title && !description) {
    return null;
  }

  return (
    <div className={`PageHeader ${color ? `theme--${color}` : ''}`}>
      {hasImage && (
        <div className="PageHeader__image">
          <Image
            url={image.url}
            alt={image.alt}
            // we only need a single width for the image; it's always
            // full-width
            sourceSizes={[{ layoutWidth: FULL_VIEWPORT }]}
          />
        </div>
      )}

      {title && (
        <h1 className="PageHeader__title">
          <span>{title}</span>
        </h1>
      )}

      {description && (
        <p
          className="PageHeader__description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      <style jsx>{styles}</style>
    </div>
  );
}

PageHeader.defaultProps = {
  color: 'default',
  image: undefined,
  title: undefined,
  description: undefined
};

PageHeader.propTypes = {
  // Eventually we're going to want a named palette and helper classes
  // Not inlining this, in anticipation of AMP
  color: string,
  image: shape({
    url: string,
    alt: string
  }),
  title: string,
  description: string
};

export default PageHeader;
